import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import * as UI from '../common';
import { InputComponent } from '../core/Forms';
import userPool from '../../utils/userPool';
import { CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { formatNumber, ValidateFormSubmit } from '../../utils';
import { INDUSTRIES } from '../../constants/industries';
import { validateForm } from '../../modules/auth/register';
import { clearFieldError } from '../../utils/handleErrors';
import TermsConditions from './TermsConditions';
import { Popup } from '../common/popup';


const RegisterView: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [value, setValue] = useState('');
  const [, setFormSubmitted] = useState(false);
  const [acceptedToc, setAcceptedToc] = useState(false);
  const [isSubmitted, setIsSubmitted] = React.useState(false);
  const [showModal, setShowModal] = useState(false); 

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const [formData, setFormData] = useState({
    firstName: '',
        lastName: '',
        phone: '', 
    email: '',
    createPassword: '',
    confirmPassword: '',
    businessName: '',
  });

  const [errors, setErrors] = useState({
    firstName: '',
    lastName: '',
    phone: '', 
    email: '',
    createPassword: '',
    confirmPassword: '',
    businessName: '',
  });

  const errorRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (error && errorRef.current) {
      errorRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [error]);

  React.useEffect(() => {
    if (formData.createPassword) {
      if (formData.createPassword !== formData.confirmPassword) {
        setErrors({ ...errors, createPassword: 'Passwords must match' });
      } else if (!/^(?=.*[a-zA-Z])(?=.*[0-9])/.test(formData.createPassword)) {
        setErrors({
          ...errors,
          createPassword: 'Password must be alphanumeric',
        });
      } else {
        setErrors({ ...errors, createPassword: '' });
      }
    }
  }, [formData.createPassword]);

  const [validationResults, setValidationResults] = useState({
    firstName: '',
    lastName: '',
    phone: '', 
    email: '',
    createPassword: '',
    confirmPassword: '',
    businessName: '',
  });

  const handleInputChange = (event: any) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: name === 'email' ? value.toLowerCase() : value });
    if (name === 'createPassword') {
      if (value !== formData.confirmPassword) {
        setErrors({ ...errors, createPassword: 'Passwords must match' });
      } else if (!/^(?=.*[a-zA-Z])(?=.*[0-9])/.test(value)) {
        setErrors({
          ...errors,
          createPassword: 'Password must be alphanumeric',
        });
      } else {
        setErrors({ ...errors, createPassword: '' });
      }
    } else {
      const errors = validateForm(name, value, formData, validationResults);
      setValidationResults(errors);
    }
    clearFieldError(name, validationResults, setValidationResults);
  };

  const handleSignUp = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!acceptedToc) {
      setError('Please accept the terms and conditions');
      setLoading(false);
      return;
    }
    setLoading(true);
    setFormSubmitted(true);
    const errorFound = ValidateFormSubmit(formData, setValidationResults, setError);
    if (!errorFound) {
      console.log('form', formData);
      const formattedPhone = formatNumber(formData.phone);
      const attributeList = [
        new CognitoUserAttribute({ Name: 'email', Value: formData.email }),
         new CognitoUserAttribute({ Name: 'custom:custom_business_name', Value: formData.businessName }),
         new CognitoUserAttribute({ Name: 'given_name', Value: formData.firstName || '' }), 
      new CognitoUserAttribute({ Name: 'family_name', Value: formData.lastName || '' }), 
      new CognitoUserAttribute({ Name: 'phone_number', Value: formattedPhone || '' }), 

      ];
      setMessage('');
      setError('');
      userPool.signUp(formData.email, formData.createPassword, attributeList, attributeList, (err, result) => {
        if (err) {
          setLoading(false);
          setMessage(err.message);
          setError(err.message);
        } else {
          navigate(`/auth/confirm-account?email=${formData.email}`);
        }
      });
    } else {
      setLoading(false);
    }
  };
    
  return (
    <div className="bg-[#F2F9FD] ">
      <div className=" mt-[1em] text-center  ">
        <h1 className="text-[20px] text-center flex justify-center">Hi there, Welcome</h1>
        <p className=" text-[14px] text-center font-light md:text-[16px] md:font-normal xl:text-[16px] xl:font-sm xl:pb-[41px] xl:font-sm xl:text-[black] flex justify-center">
          Create an account to get started!
        </p>
        {message && !error && <div className="text-red-600 text-center my-4">{message}</div>}
        {error && (
          <div ref={errorRef} className="text-red-600  md:text-center text-center my-4">
            {error}
          </div>
        )}

        <button
          disabled
          className="flex justify-center mx-auto mt-[1em] py-2 px-4 w-full md:w-[400px] gap-2 rounded-md xl:px-4 xl:w-[400px] xl:h-[48px] xl:flex xl:gap-2 xl:mx-auto xl:justify-center xl:py-2 xl:rounded-md bg-white border border-[#A4A4A4] text-black xl:font-bold xl:ml-[em] 2xl:ml-[em]"
         
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"
            alt="Google logo"
            className="w-5 h-5 inline-block  xl:inline-block xl:h-6 xl:w-6"
          />
          <p className="text-[14px] font-medium md:text-[16px] xl:text-[16px] xl:font-medium"> Sign up with Google</p>
        </button>
      </div>
      <div className="xl-hidden lg:flex-col lg:items-center lg:justify-center lg:min-h-screen lg:mx-auto lg:py-[30px] ">
        <div className="  lg:px-6 lg:py-8 lg:rounded-xl max-w-screen-md mx-auto">
          <form onSubmit={handleSignUp}>
            <div className='flex flex-col justify-center xl:ml-[1.9em] biglg:ml-[1em] lg:ml-[-3.7em] md:ml-[0.5em] bigmd:ml-[4em]'>
            <div className=" mt-[1.5em] xl:mt-[-3em] 2xl:mt-[-3em] biglg:mt-[-1em] md:mt-[1.8em] rounded-md md:ml-[10em] lg:ml-[2em] xl:flex xl:justify-center xl:placeholder:text-[16px] xl:h-[48px] xl:rounded xl:ml-[-2em] 2xl:ml-[-3em] ">
              <div className=" xl:w-[434px] md:w-[434px] xl:pr-[15px] xl:py-[37px]">
                <label htmlFor="Business Name" className=" text-[12px]  md:text-[13px] xl:block xl:font-sm xl:text-[13px] xl:text-black ">
                  Business Name
                </label>
                <InputComponent
                  placeholder="Business Name"
                  type="text"
                  name="businessName"
                  value={formData.businessName}
                  handleChange={handleInputChange}
                  error={validationResults.businessName}
                  className="w-full rounded-md  md:w-[434px] xl:w-[434px]"
                />
              </div>
            </div>
            <div className=" mt-[1em] md:ml-[10em] lg:ml-[2em] xl:flex xl:justify-center xl:placeholder:text-[16px] xl:h-[48px]  xl:rounded  xl:mt-[35px] xl:ml-[-2em] 2xl:ml-[-3em] ">
              <div className=" xl:w-[434px] md:w-[434px] xl:pr-[15px] xl:py-[37px]">
                <label htmlFor="Email" className=" text-[12px] md:text-[13px] xl:block xl:font-sm xl:text-[13px] xl:text-black ">
                  Email
                </label>
                <InputComponent
                  placeholder="Email"
                  name="email"
                  type="text"
                  value={formData.email}
                  handleChange={handleInputChange}
                  error={validationResults.email}
                  className="xl:w-[434px] w-full rounded-md md:w-[434px]"
                />
              </div>
            </div>

            <div className=" mt-[1em] xl:mt-[4em] md:mt-[1em]  md:ml-[10em] biglg:mt-[1em] lg:mt-[1em] lg:ml-[2em] xl:flex xl:justify-center xl:placeholder:text-[16px] xl:h-[48px] xl:rounded xl:py-[17px] xl:ml-[-2em]  2xl:ml-[-3em] ">
              <div className=" xl:w-[434px] md:w-[434px] xl:pr-[20px]  ">
                <label htmlFor="Password" className=" text-[12px] md:text-[13px] xl:block xl:font-sm xl:text-[13px] xl:text-black ">
                 Create Password
                </label>
                <InputComponent
                  placeholder="Create Password"
                  name="createPassword"
                  type="password"
                  value={formData.createPassword}
                  handleChange={handleInputChange}
                  className="w-full h-[48px] rounded-md xl:w-[434px] md:w-[434px]"
                  imageClassName="ml-[21em] 375:ml-[19em]  414:ml-[21em] 360:ml-[18em] 412:ml-[21.5em]  w-[24px] h-[24px] mt-[-3.5em] md:ml-[24em] md:mt-[-3em] lg:ml-[25em] lg:mt-[-3.5em] xl:ml-[25em] xl:mt-[-3.5em] biglg:ml-[25em] 540:ml-[29em] 540:mt-[-3.5em]"
                  error={validationResults.createPassword}
                />
              </div>
            </div>

            <div className="mt-[-3em] md:mt-[-3em]  lg:mt-[-3em] xl:mt-[4em] md:ml-[10em]  xl:ml-[3.3em] 2xl:ml-[3.3em] biglg:ml-[1.9em] lg:ml-[2em]">
              <div>
                <label
                  htmlFor="Password"
                  className=" text-[12px] md:text-[13px] xl:block xl:font-sm xl:font-weight-[400] xl:text-[13px] xl:text-black "
                >
                  Confirm Password
                </label>
                <InputComponent
                  placeholder="Confirm Password"
                  name="confirmPassword"
                  type="password"
                  value={formData.confirmPassword}
                  handleChange={handleInputChange}
                  error={validationResults.confirmPassword}
                  className="w-full rounded-md xl:w-[434px] md:w-[434px]"
                  imageClassName="ml-[21em] 375:ml-[19em]  414:ml-[21em] 360:ml-[18em] 412:ml-[21.5em] w-[24px] h-[24px] mt-[-3.5em] md:ml-[24em] lg:ml-[25em] lg:mt-[-3.5em] xl:ml-[25em] xl:mt-[-3.5em] biglg:ml-[25em] 540:ml-[29em] 540:mt-[-3.5em]"
                />
              </div>
            </div>

            <div className="mt-[1em] flex justify-center lg:mt-[1em]  ">
              <div>
                <label className="xl:flex xl:items-center">
                  <input
                    type="checkbox"
                    checked={acceptedToc}
                    onChange={(e) => setAcceptedToc(e.target.checked)}
                    style={{ height: '20px', width: '20px' }}
                  />
                  <span className=" text-[11px] ml-3  xl:ml-3 xl:align-middle xl:text-[12px]">
                    I have read and I agree to all the{' '}
                    <a href="#" className="text-[11px] text-blue-500 xl:text-blue-500 xl:underline xl:text-[12px] " onClick={handleShowModal}>
                      Terms and conditions.
                    </a>
                  </span>
                </label>
              </div>
            </div>
            {showModal && (
          
          <Popup
            title="Terms and Conditions"
            subTitle="Last Updated: 27th October, 2023"
            show={true}
            onClose={() => setShowModal(false)}
            position={'middle'}
          >
            <TermsConditions
              onClose={() => setShowModal(false)}
              showModal ={showModal }
            />
          </Popup>
        )}
            <div className="flex w-full mt-[2em] pb-6 md:ml-[10em] md:w-[434px] lg:ml-[2em]  xl:w-full xl:h-[48px] xl:flex xl:mt-[8px] xl:justify-center xl:py-[40px] xl:pr-[12px] xl:ml-[0.1em] 2xl:ml-[-1em]">
              <div className=" w-full xl:w-[434px] xl:mt-[2em] xl:ml-[-1em]">
                <UI.Button text="Register" isLoading={loading} />
              </div>
            </div>
            </div>
          </form>
        </div>
      </div>
  
    </div>
  );
};

export { RegisterView };


